import React from 'react';

import './ImageBox.scss';
import Icon from 'Core/Components/Icon';
import TextBox from 'RLX/Forms/TextBox';
import ImageSelector from 'RLX/Forms/ImageSelector';


class ImageBox extends React.Component {
  constructor (props) {
    super(props);
    this.state = { broken: false };
    this.considerBroken = this.considerBroken.bind(this);
    this.considerUnbroken = this.considerUnbroken.bind(this);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
  }

  componentWillReceiveProps (newProps) {
    if (newProps.value && newProps.value !== this.props.value) {
      this.considerUnbroken();
    }
  }

  considerBroken () {
    const broken = true;
    this.setState({ broken });
  }

  considerUnbroken (event) {
    if (event) event.preventDefault();
    const broken = false;
    this.setState({ broken });
  }

  render () {
    const { broken } = this.state;
    const { value } = this.props;
    const brokenImage = '/assets/rlx/fallback.png';
    const { className, children, onChange, ...otherProps } = this.props;

    return (
      <div className={'Field ImageBox' + (className ? ' ' + className : '')}>
        <div className="ImageBox-ImageWrapper">
          <img
            src={!value || broken ? brokenImage : value}
            onError={this.considerBroken}
            className="ImageBox-Image"
          />
        </div>
        <TextBox onChange={onChange} {...otherProps}>
          <ImageSelector onSelect={onChange} current={value} />
          {broken || !value || !value.length ? null : (
            <a href={value} title="Open Image in New Tab" target="_blank" style={{ marginLeft: 5 }}>
              <Icon fa="external-link"/>
            </a>
          )}
          {!children ? null : children}
        </TextBox>
      </div>
    );
  }
};

export default ImageBox;



// WEBPACK FOOTER //
// ./client/RLX/Forms/ImageBox/ImageBox.jsx